// extracted by mini-css-extract-plugin
export default {"title":"R8U3_Rat2KfLEgbRZ4yD"};